module.exports = __webpack_public_path__ + "static/media/visa.ef710504.svg";